// extracted by mini-css-extract-plugin
export default {"container":"LoginCard_container__uZQrI","heading":"LoginCard_heading__fNRAe","loginForm":"LoginCard_loginForm__jQj3s"};